export type PageFooterProps = {
  title: string;
};

export default function PageFooter({ title }: PageFooterProps) {
  return (
    <footer className="fl-flex fl-items-center fl-justify-center fl-p-2 fl-bg-light fl-text-xs">
      {`${title} @ ${new Date().getFullYear()}`}
    </footer>
  );
}
